import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n  width: ', 'px;\n  color: ', ';\n  background-color: ', ';\n'], ['\n  height: 100%;\n  width: ', 'px;\n  color: ', ';\n  background-color: ', ';\n']);

import styled from 'styled-components';

import { containerClosedWidth } from '../../../../shared-variables';
import { getProvided } from '../../../../theme/util';

var SkeletonGlobalNavigationInner = styled.div(_templateObject, containerClosedWidth(), function (_ref) {
  var theme = _ref.theme;
  return getProvided(theme).text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getProvided(theme).background.primary;
});

SkeletonGlobalNavigationInner.displayName = 'SkeletonGlobalNavigationInner';
export default SkeletonGlobalNavigationInner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/skeleton/styled/SkeletonGlobalNavigationInner.js
// module id = 736
// module chunks = 0